import StartSystemAdminView from './StartSystemAdminView';

export default StartSystemAdminView;